// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DateRangeFilter Component Styles */
.date-picker-dropdown {
  z-index: 1000;
}

/* Predefined Ranges Styling */
.date-picker-dropdown .rdrDefinedRangesWrapper {
  border-right: 1px solid #e2e8f0 !important;
  background-color: #f8fafc !important;
  font-size: 14px !important;
  width: 140px !important;
}

.date-picker-dropdown .rdrStaticRange {
  border-bottom: 1px solid #e2e8f0 !important;
  background-color: #f8fafc !important;
  color: #475569 !important;
  font-size: 13px !important;
  padding: 8px 12px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.date-picker-dropdown .rdrStaticRange:hover,
.date-picker-dropdown .rdrStaticRange:focus {
  background-color: #f1f5f9 !important;
  color: #1e40af !important;
}

.date-picker-dropdown .rdrStaticRange.rdrStaticRangeSelected {
  background-color: #dbeafe !important;
  color: #1e40af !important;
  font-weight: 500 !important;
}

.date-picker-dropdown .rdrStaticRangeLabel {
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
}

/* Calendar Styling */
.date-picker-dropdown .rdrMonth {
  padding: 0 0.8em 0.8em !important;
}

.date-picker-dropdown .rdrMonthName {
  color: #475569 !important;
  font-weight: 500 !important;
  padding: 0.8em !important;
  font-size: 14px !important;
}

.date-picker-dropdown .rdrWeekDay {
  color: #64748b !important;
  font-weight: 400 !important;
  font-size: 12px !important;
}

.date-picker-dropdown .rdrDay {
  margin-top: 0.2em !important;
  color: #334155 !important;
}

.date-picker-dropdown .rdrDay.rdrDayDisabled {
  color: #cbd5e1 !important;
}

.date-picker-dropdown .rdrDayToday .rdrDayNumber span:after {
  background: #3b82f6 !important;
}

.date-picker-dropdown .rdrDayHovered {
  border-radius: 4px !important;
  background-color: #f1f5f9 !important;
}

.date-picker-dropdown .rdrDayActive {
  border-radius: 4px !important;
  background-color: #3b82f6 !important;
  color: #fff !important;
}

.date-picker-dropdown .rdrInRange {
  background-color: #dbeafe !important;
  color: #1e40af !important;
}

.date-picker-dropdown .rdrStartEdge,
.date-picker-dropdown .rdrEndEdge {
  background-color: #3b82f6 !important;
  border-radius: 4px !important;
  color: #fff !important;
}

/* Fix for text color in selected ranges */
.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #000 !important;
}

.date-picker-dropdown .rdrMonthAndYearPickers select {
  color: #000 !important;
}

/* Input styling */
.date-range-input:focus,
.date-range-input:hover {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
} `, "",{"version":3,"sources":["webpack://./src/components/UI/DateRangeFilter.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;;;;;;;;EAQE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;;EAEE,gCAAgC;EAChC,wDAAwD;AAC1D","sourcesContent":["/* DateRangeFilter Component Styles */\n.date-picker-dropdown {\n  z-index: 1000;\n}\n\n/* Predefined Ranges Styling */\n.date-picker-dropdown .rdrDefinedRangesWrapper {\n  border-right: 1px solid #e2e8f0 !important;\n  background-color: #f8fafc !important;\n  font-size: 14px !important;\n  width: 140px !important;\n}\n\n.date-picker-dropdown .rdrStaticRange {\n  border-bottom: 1px solid #e2e8f0 !important;\n  background-color: #f8fafc !important;\n  color: #475569 !important;\n  font-size: 13px !important;\n  padding: 8px 12px !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.date-picker-dropdown .rdrStaticRange:hover,\n.date-picker-dropdown .rdrStaticRange:focus {\n  background-color: #f1f5f9 !important;\n  color: #1e40af !important;\n}\n\n.date-picker-dropdown .rdrStaticRange.rdrStaticRangeSelected {\n  background-color: #dbeafe !important;\n  color: #1e40af !important;\n  font-weight: 500 !important;\n}\n\n.date-picker-dropdown .rdrStaticRangeLabel {\n  color: inherit !important;\n  font-size: inherit !important;\n  font-weight: inherit !important;\n}\n\n/* Calendar Styling */\n.date-picker-dropdown .rdrMonth {\n  padding: 0 0.8em 0.8em !important;\n}\n\n.date-picker-dropdown .rdrMonthName {\n  color: #475569 !important;\n  font-weight: 500 !important;\n  padding: 0.8em !important;\n  font-size: 14px !important;\n}\n\n.date-picker-dropdown .rdrWeekDay {\n  color: #64748b !important;\n  font-weight: 400 !important;\n  font-size: 12px !important;\n}\n\n.date-picker-dropdown .rdrDay {\n  margin-top: 0.2em !important;\n  color: #334155 !important;\n}\n\n.date-picker-dropdown .rdrDay.rdrDayDisabled {\n  color: #cbd5e1 !important;\n}\n\n.date-picker-dropdown .rdrDayToday .rdrDayNumber span:after {\n  background: #3b82f6 !important;\n}\n\n.date-picker-dropdown .rdrDayHovered {\n  border-radius: 4px !important;\n  background-color: #f1f5f9 !important;\n}\n\n.date-picker-dropdown .rdrDayActive {\n  border-radius: 4px !important;\n  background-color: #3b82f6 !important;\n  color: #fff !important;\n}\n\n.date-picker-dropdown .rdrInRange {\n  background-color: #dbeafe !important;\n  color: #1e40af !important;\n}\n\n.date-picker-dropdown .rdrStartEdge,\n.date-picker-dropdown .rdrEndEdge {\n  background-color: #3b82f6 !important;\n  border-radius: 4px !important;\n  color: #fff !important;\n}\n\n/* Fix for text color in selected ranges */\n.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.date-picker-dropdown .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #000 !important;\n}\n\n.date-picker-dropdown .rdrMonthAndYearPickers select {\n  color: #000 !important;\n}\n\n/* Input styling */\n.date-range-input:focus,\n.date-range-input:hover {\n  border-color: #3b82f6 !important;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
